import React, { useEffect, useState } from 'react';
import {
  Flex,
  Box,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  Alert,
  AlertIcon,
  Spinner
} from '@chakra-ui/react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const CallbackPage = () => {
  const [error, setError] = useState(null);
  const { handleRedirectCallback } = useAuth0(); // Removed unused isAuthenticated and isLoading
  const navigate = useNavigate();
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const cardBg = useColorModeValue('white', 'gray.700');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        await handleRedirectCallback();
        // Redirect to the original page or dashboard after successful auth
        navigate('/jobs/dashboard');
      } catch (err) {
        setError(err.message || 'Authentication failed');
      }
    };

    handleCallback();
  }, [handleRedirectCallback, navigate]);

  return (
    <Flex minH="100vh" align="center" justify="center" bg={bgColor}>
      <Box
        w="full"
        maxW="md"
        p={8}
        borderRadius="lg"
        boxShadow="xl"
        bg={cardBg}
      >
        <VStack spacing={6} align="stretch">
          <Box textAlign="center">
            <Heading as="h1" size="xl" mb={2}>
              Completing Authentication
            </Heading>
            <Text color="gray.500">Please wait while we verify your credentials</Text>
          </Box>

          {error ? (
            <Alert status="error" borderRadius="md">
              <AlertIcon />
              {error}
            </Alert>
          ) : (
            <Flex direction="column" align="center" justify="center" py={8}>
              <Spinner
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="blue.500"
                size="xl"
                mb={4}
              />
              <Text>Processing your login...</Text>
            </Flex>
          )}
        </VStack>
      </Box>
    </Flex>
  );
};

export default CallbackPage;